import {CSSProperties} from "react"

export default function HouseMehrfamilienMittelhaus(props: {
  selected_menu_item: string;
  onEnterElement: (id: string) => void;
  onLeaveElement: (id: string) => void;
  onClickElement: (id: string) => void;
  element_styling_function: (id: string) => CSSProperties;
  icon_styling_function: (id: string) => CSSProperties;
  outline_styling_function: (id: string) => CSSProperties;
}) {
  const enter_element = props.onEnterElement;
  const leave_element = props.onLeaveElement;
  const click_element = props.onClickElement;
  const element_styling_function = props.element_styling_function;
  const icon_styling_function = props.icon_styling_function;
  const outline_styling_function = props.outline_styling_function; 

  return (  
    <>
  {/*BEGIN SVG*/}
    <svg  viewBox="0 0 3000 3000">
  <defs>
    <style>{`
      .cls-1, .cls-2, .cls-3 {
        fill: none;
      }

      .cls-4 {
        fill: #a67359;
      }

      .cls-2 {
        stroke: #dfe6ee;
        stroke-width: 3px;
      }

      .cls-5 {
        fill: #f19200;
      }

      .cls-6 {
        fill: #5961a6;
      }

      .cls-7 {
        fill: #dfe6ee;
      }

      .cls-8 {
        fill: #0df2c9;
      }

      .cls-9 {
        isolation: isolate;
      }

      .cls-10 {
        fill: #40a8bf;
      }

      .cls-11 {
        clip-path: url(#clippath-17);
      }

      .cls-12 {
        clip-path: url(#clippath-19);
      }

      .cls-13 {
        clip-path: url(#clippath-11);
      }

      .cls-14 {
        clip-path: url(#clippath-16);
      }

      .cls-15 {
        clip-path: url(#clippath-18);
      }

      .cls-16 {
        clip-path: url(#clippath-10);
      }

      .cls-17 {
        clip-path: url(#clippath-15);
      }

      .cls-18 {
        clip-path: url(#clippath-13);
      }

      .cls-19 {
        clip-path: url(#clippath-14);
      }

      .cls-20 {
        clip-path: url(#clippath-12);
      }

      .cls-21 {
        mix-blend-mode: multiply;
      }

      .cls-22 {
        fill: #f2b00d;
      }

      .cls-23 {
        clip-path: url(#clippath-1);
      }

      .cls-24 {
        clip-path: url(#clippath-3);
      }

      .cls-25 {
        clip-path: url(#clippath-4);
      }

      .cls-26 {
        clip-path: url(#clippath-2);
      }

      .cls-27 {
        clip-path: url(#clippath-7);
      }

      .cls-28 {
        clip-path: url(#clippath-6);
      }

      .cls-29 {
        clip-path: url(#clippath-9);
      }

      .cls-30 {
        clip-path: url(#clippath-8);
      }

      .cls-31 {
        clip-path: url(#clippath-5);
      }

      .cls-32 {
        fill: #fff;
      }

      .cls-33 {
        fill: #26d93b;
      }

      .cls-34 {
        fill: #f29200;
      }

      .cls-35 {
        fill: #f19000;
      }

      .cls-3 {
        stroke: #f29400;
        stroke-miterlimit: 10;
        stroke-width: 7px;
      }

      .cls-36 {
        fill: #f29404;
      }

      .cls-37 {
        fill: #f25e0d;
      }

      .cls-38 {
        clip-path: url(#clippath);
      }

      .cls-39 {
        fill: #d9e51a;
      }
    `}</style>
    <clipPath id="clippath">
      <rect className="cls-1" x="119.21" y="39.46" width="2741.57" height="2898.33"></rect>
    </clipPath>
    <clipPath id="clippath-1">
      <rect className="cls-1" x="119.21" y="39.46" width="2741.57" height="2898.33"></rect>
    </clipPath>
    <clipPath id="clippath-2">
      <rect className="cls-1" x="436.85" y="698.84" width="2403.78" height="1700.79"></rect>
    </clipPath>
    <clipPath id="clippath-3">
      <rect className="cls-1" x="944.38" y="562.62" width="1706.3" height="1738.3"></rect>
    </clipPath>
    <clipPath id="clippath-4">
      <rect className="cls-1" x="617.12" y="97.11" width="2077.11" height="586.33"></rect>
    </clipPath>
    <clipPath id="clippath-5">
      <rect className="cls-1" x="797.66" y="169.18" width="898.95" height="355.15"></rect>
    </clipPath>
    <clipPath id="clippath-6">
      <rect className="cls-1" x="1681.02" y="282.45" width="770.64" height="303.38"></rect>
    </clipPath>
    <clipPath id="clippath-7">
      <rect className="cls-1" x="1725.32" y="698.84" width="106.21" height="990.09"></rect>
    </clipPath>
    <clipPath id="clippath-8">
      <rect className="cls-1" x="983.19" y="1985.58" width="1381.1" height="780.79"></rect>
    </clipPath>
    <clipPath id="clippath-9">
      <rect className="cls-1" x="1114.78" y="711.1" width="1408.68" height="1482.84"></rect>
    </clipPath>
    <clipPath id="clippath-10">
      <rect className="cls-1" x="1430.55" y="1394.4" width="291.88" height="1089.93"></rect>
    </clipPath>
    <clipPath id="clippath-11">
      <rect className="cls-1" x="2025.09" y="1000.48" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-12">
      <rect className="cls-1" x="1537.98" y="171.85" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-13">
      <rect className="cls-1" x="1182.56" y="282.45" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-14">
      <rect className="cls-1" x="2040.82" y="329.46" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-15">
      <rect className="cls-1" x="1744.31" y="1199.88" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-16">
      <rect className="cls-1" x="1167.86" y="2315.17" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-17">
      <rect className="cls-1" x="1167.86" y="2315.17" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-18">
      <rect className="cls-1" x="1167.86" y="2315.17" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-19">
      <rect className="cls-1" x="1598.8" y="1448.52" width="121.62" height="586.33"></rect>
    </clipPath>
  </defs>
  
  <g className="cls-9">
    <g id="MMH">
      <g id="interaktive_flaechen">
        <polygon id="fassade" className="cls-37" points="139.53 505.66 122.52 2472.91 989.21 2283.7 999.84 1171.81 1735.43 1146.29 1735.43 2041.33 1760.94 2056.22 1757.64 2083.85 1740.63 2085.98 1741.81 2101.1 1767.32 2113.62 1769.45 2214.48 2362.6 2064.72 2849.45 1951.33 2854.65 687.08 139.53 505.66" onPointerEnter={()=>{enter_element("fassade")}} onPointerLeave={()=>{leave_element("fassade")}} onClick={()=>{click_element("fassade")}} style={element_styling_function("fassade")}></polygon>
        <polygon id="dach" className="cls-8" points="133.86 39.46 150.87 499.52 965.83 559.52 2670.39 670.07 2860.79 687.08 2832.44 397.95 133.86 39.46" onPointerEnter={()=>{enter_element("dach")}} onPointerLeave={()=>{leave_element("dach")}} onClick={()=>{click_element("dach")}} style={element_styling_function("dach")}></polygon>
        <polygon id="photovoltaik" className="cls-39" points="801.89 165.51 1400.47 243.46 1676.85 497.16 1672.6 507.08 1041.42 455.59 801.89 165.51" onPointerEnter={()=>{enter_element("photovoltaik")}} onPointerLeave={()=>{leave_element("photovoltaik")}} onClick={()=>{click_element("photovoltaik")}} style={element_styling_function("photovoltaik")}></polygon>
        <polygon id="solarthermie" className="cls-4" points="1699.53 281.73 1703.78 293.07 1995.75 534.96 2439.37 575.11 2443.62 566.61 2131.81 334.17 1699.53 281.73" onPointerEnter={()=>{enter_element("solarthermie")}} onPointerLeave={()=>{leave_element("solarthermie")}} onClick={()=>{click_element("solarthermie")}} style={element_styling_function("solarthermie")}></polygon>
        <g id="keller" onPointerEnter={()=>{enter_element("keller")}} onPointerLeave={()=>{leave_element("keller")}} onClick={()=>{click_element("keller")}} style={element_styling_function("keller")}>
          <g className="cls-38">
            <path className="cls-10" d="M1736.61,2098.61v-15.59l14.17-2.83,1.42-25.51-15.59-7.09-720.47,145.98-22.68-11.75-3.54,109.67-870.71,187.09,20.31,459.21,1874.88-463.59,2.83-304.72,236.69-55.75,26.93-15.12s35.43-7.09,41.1-15.59c5.67-8.5,35.43-18.42,35.43-18.42l2.83-76.54-589.61,123.31-34.02-12.76Z"></path>
          </g>
        </g>
        <g id="heizung" onPointerEnter={()=>{enter_element("heizung")}} onPointerLeave={()=>{leave_element("heizung")}} onClick={()=>{click_element("heizung")}} style={element_styling_function("heizung")}>
          <g className="cls-23">
            <path className="cls-22" d="M1532.76,2205.27l-89.29,12.52,5.67,215.43s161.58,46.77,204.8,48.9c43.23,2.13,58.82-21.26,58.82-21.26,0,0,2.36-251.58.71-260.08-1.65-8.5-20.55-14.17-20.55-14.17l-.47-93.54-45.35,10.16,14.65,6.14v73.23s-2.83-1.65-22.68,0c-19.84,1.65-41.1,8.5-41.1,8.5l-12.76-4.49,3.54-59.53-17.01-7.79-85.04,17.95-.71,21.02,46.77,19.84v27.16ZM1001.26,1704.25l-11.34,496.06,773.39-152.6,3.31-436.54-765.36,93.07ZM1772.28,1146.29l-771.02,22.68v563.62l765.36-70.39,5.67-515.91Z"></path>
          </g>
        </g>
        <polygon id="lueftung" className="cls-6" points="1775.83 708.34 1826.85 712.12 1825.67 1673.54 1774.65 1682.04 1740.63 1667.16 1737.56 1636.22 1774.65 1643.77 1777.95 1216.45 1735.43 1211.02 1734.96 1182.67 1775.83 1184.56 1775.83 708.34" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={element_styling_function("lueftung")}></polygon>
        <g id="fenster" onPointerEnter={()=>{enter_element("fenster")}} onPointerLeave={()=>{leave_element("fenster")}} onClick={()=>{click_element("fenster")}} style={element_styling_function("fenster")}>
          <g className="cls-26">
            <path className="cls-33" d="M737.32,1056l2.36-351.5-291.5-5.67-11.34,357.17h300.47ZM739.68,1514.74l3.31-396.38h-300.94l-5.2,419.53,302.83-23.15ZM739.68,1543.56l-302.83,28.35,5.2,438.9,297.64-42.52v-424.72ZM436.85,2399.62l306.14-62.36v-334.49l-306.14,50.55v346.3ZM1122.83,995.43l215.43-3.78-1.42-262.68-214.02-9.45v275.91ZM1505.04,989.76h188.98v-247.56l-188.5-7.09-.47,254.65ZM2015.75,984.57l1.42-229.61-136.06-4.25v235.28l134.65-1.42ZM2015.75,1438.11l1.42-231.02-134.65,5.67v239.53l133.23-14.17ZM1881.1,1908.66l136.06-25.51-1.42-230.08-133.23,16.06-1.42,239.53ZM1912.28,2185.98l106.3-27.87v-74.17l-106.3,22.68v79.37ZM2137.64,984.57h123.31v-221.1l-123.31-4.25v225.35ZM2137.64,1426.77l123.31-11.81-1.42-220.63-121.89,5.67v226.77ZM2136.22,1863.31l124.72-24.09-1.42-218.27-123.31,15.59v226.77ZM2163.15,2123.62l97.8-22.2v-72.28l-97.8,21.26v73.23ZM2362.99,1738.58l-5.67,314.65,147.4-36.85,8.5,2.83,1.42-303.78-151.65,23.15ZM2362.99,1403.62l-1.42,306.61,153.07-22.68,1.42-299.05-153.07,15.12ZM2516.06,1029.92l1.42-253.7-154.49-7.09v265.98l153.07-5.2ZM2362.99,1375.75l154.49-14.17v-286.77l-153.07,1.89-1.42,299.06ZM2715.9,1549.23l-6.14,198.42,127.56-17.01s3.31-181.42,3.31-192.76-124.72,11.34-124.72,11.34M2829.29,1358.83l-6.14-198.43-107.24,3.31v198.43c0,11.34,113.39-3.31,113.39-3.31M2837.32,982.3l3.31-190.39-124.72-13.7,5.67,198.43,115.75,5.67Z"></path>
          </g>
        </g>
      </g>
      <g id="rahmen">
        <g id="fassade_rahmen" style={outline_styling_function("fassade")}>
          <g className="cls-24">
            <path className="cls-3" d="M950.02,570.07l-2.13,1722.05v4.41s4.29-.99,4.29-.99l27.64-6.38,2.69-.62.03-2.76c3.53-369.52,7.07-739.02,10.6-1108.54,242.86-8.42,485.76-16.85,728.62-25.27v893.43l1.74,1.01c7.84,4.57,15.68,9.15,23.53,13.72-.9,7.55-1.8,15.09-2.71,22.64-4.76.6-9.53,1.19-14.29,1.79l-3.32.42.26,3.33,1.18,15.12.16,1.99,1.79.88c7.87,3.86,15.73,7.72,23.6,11.58.69,32.91,1.39,65.83,2.08,98.74l.09,4.4,4.26-1.08,593.15-149.76,222.56-42.95,3.1-.6-.28-3.15c-2.62-29.55-5.23-59.1-7.85-88.65,15.07-10.15,30.15-20.3,45.22-30.44,9.29-.61,18.58-1.22,27.88-1.83l3.27-.21v-3.28s-.47-1222.68-.47-1222.68v-3.29s-3.28-.21-3.28-.21l-1689.68-106.3-3.72-.23v3.72Z"></path>
          </g>
        </g>
        <g id="dach_rahmen" style={outline_styling_function("dach")}>
          <g className="cls-25">
            <path className="cls-3" d="M630.31,108.41c113.94,147.05,227.89,294.1,341.83,441.14l4.08,16.75.61,2.5,2.57.17,1704.57,110.55,3.28.21.42-3.26,2.6-20.32.26-2.02-1.63-1.22-452.83-338.98-.73-.55-.91-.12L633.53,102.79l-8.43-1.11,5.21,6.72Z"></path>
          </g>
        </g>
        <g id="photovoltaik_rahmen" style={outline_styling_function("photovoltaik")}>
          <g className="cls-31">
            <polygon className="cls-3" points="814.82 174.8 1407.26 247.08 1408.38 247.22 1409.21 247.98 1689.84 505.93 1692.04 507.96 1690.38 510.45 1684.71 518.95 1683.57 520.67 1681.51 520.5 1053.63 468.06 1052.18 467.94 1051.24 466.82 811.71 180.52 806.03 173.73 814.82 174.8"></polygon>
          </g>
        </g>
        <g id="solarthermie_rahmen" style={outline_styling_function("solarthermie")}>
          <g className="cls-28">
            <polygon className="cls-3" points="1703.6 288.71 2131.64 340.68 2132.55 340.79 2133.29 341.34 2444.63 571.42 2447.11 573.25 2445.61 575.93 2443.25 580.19 2442.16 582.16 2439.91 581.98 1996.29 546.54 1995.16 546.45 1994.29 545.71 1700.91 294.85 1692.1 287.32 1703.6 288.71"></polygon>
          </g>
        </g>
        <g id="lueftung_rahmen" style={outline_styling_function("lueftung")}>
          <g className="cls-27">
            <path className="cls-3" d="M1767.66,743.99l56.69,2.84,3.68.18v-42.99l-3.41-.09-53.86-1.42-3.31-.09-.27,3.3-2.83,34.49-.3,3.6,3.61.18ZM1764.24,1215.68h54.52v-35.23l-3.38-.11-48.9-1.65-31.78-2.12-3.68-.25-.05,3.69-.47,32.13-.05,3.55h33.79ZM1821.13,1675.41v-33.73l-3.73.24c-16.78,1.09-33.56,2.18-50.34,3.26-11.12-3.71-22.24-7.42-33.37-11.12l-4.57-1.52-.03,4.82-.24,34.02-.02,2.47,2.32.84,28.58,10.39.77.28.82-.09,56.69-6.38,3.11-.35v-3.13Z"></path>
          </g>
        </g>
        <g id="keller_rahmen" style={outline_styling_function("keller")}>
          <g className="cls-30">
            <path className="cls-3" d="M1736.84,2102.39v-10.3l11.36-2.27,2.66-.53.15-2.71,1.42-25.51.13-2.39-2.18-.99-15.59-7.09-1.03-.47-1.11.23c-239.76,48.58-479.5,97.16-719.26,145.74-7.19-3.73-14.39-7.45-21.58-11.18l-5.11-2.65v579.48l4.44-1.24c251.6-70.41,503.19-140.82,754.79-211.23,5.78,2.22,11.56,4.45,17.34,6.67l1.11.42,1.13-.33,246.61-72.28,2.49-.73.02-2.6c.94-100.66,1.87-201.32,2.81-301.98,78.01-18.37,156.02-36.75,234.02-55.12l.48-.11.43-.24c8.82-4.95,17.63-9.9,26.45-14.85,7.25-1.48,36.78-7.98,42.78-16.97,3.64-5.46,22.56-13.35,33.63-17.05l2.3-.77.09-2.42,2.84-76.53.16-4.47-4.38.92c-196.2,41.03-392.41,82.07-588.61,123.1-10.26-3.85-20.53-7.7-30.79-11.55Z"></path>
          </g>
        </g>
        <g id="fenster_rahmen" style={outline_styling_function("fenster")}>
          <g className="cls-29">
            <path className="cls-3" d="M1121.84,997.82l215.43-3.78,3.46-.06-.02-3.46-1.42-262.68-.02-3.33-3.33-.15-214.02-9.45-3.66-.16v283.12l3.56-.06ZM1503.98,992.15h192.48v-254.43l-3.37-.13-188.5-7.09-3.62-.14v3.63s-.48,254.65-.48,254.65v3.51s3.5,0,3.5,0ZM2018.19,983.47l1.42-229.61.02-3.41-3.41-.11-136.06-4.25-3.61-.11v242.42l3.54-.04,134.65-1.42,3.44-.04.02-3.44ZM2018.19,1437.02l1.42-231.02.02-3.67-3.67.16-134.65,5.67-3.35.14v246.78l3.87-.41,133.23-14.17,3.11-.33.02-3.13ZM1880.69,1910.99l136.06-25.51,2.87-.54-.02-2.92-1.42-230.08-.02-3.92-3.89.47-133.23,16.06-3.06.37-.02,3.09-1.42,239.53-.03,4.24,4.17-.78ZM1912.11,2188.26l106.3-27.87,2.61-.68v-81.2l-4.23.9-106.3,22.68-2.77.59v86.74l4.39-1.15ZM2136.58,986.95h126.81v-227.98l-3.38-.12-123.31-4.25-3.62-.12v232.48h3.5ZM2136.91,1429.14l123.31-11.81,3.19-.3-.02-3.2-1.42-220.63-.02-3.64-3.64.17-121.89,5.67-3.34.15v233.96l3.83-.37ZM2135.83,1865.63l124.72-24.1,2.86-.55-.02-2.91-1.42-218.27-.03-3.94-3.91.49-123.31,15.59-3.06.39v234.1l4.16-.8ZM2162.87,2125.92l97.8-22.21,2.72-.62v-79.42l-4.24.92-97.79,21.26-2.76.6v80.43l4.28-.97ZM2358.43,1737.41l-5.67,314.65-.08,4.57,4.43-1.11c48.8-12.2,97.61-24.4,146.41-36.6,2.51.84,5.03,1.67,7.54,2.51l4.58,1.53.02-4.83,1.42-303.78.02-4.09-4.05.62-151.65,23.15-2.92.45-.05,2.95ZM2358.43,1402.49l-1.42,306.61-.02,4.08,4.03-.6,153.07-22.68,2.97-.44v-3.01s1.43-299.06,1.43-299.06l.02-3.88-3.86.38-153.07,15.12-3.14.31v3.16ZM2518.51,1028.83l1.42-253.7.02-3.36-3.36-.15-154.49-7.09-3.66-.17v273.27l3.62-.12,153.07-5.2,3.36-.11.02-3.36ZM2519.92,1360.46v-290.32l-3.54.04-153.07,1.89-3.44.04-.02,3.44-1.42,299.05-.02,3.85,3.84-.35,154.49-14.17,3.18-.29v-3.19Z"></path>
          </g>
        </g>
        <g id="heizung_rahmen" style={outline_styling_function("heizung")}>
          <g className="cls-16">
            <path className="cls-3" d="M1586.52,2182.48l-9.17-3.23c1.13-18.96,2.26-37.93,3.39-56.89l.14-2.39-2.18-1-17.01-7.8-1.05-.48-1.13.24-85.04,17.95-2.68.57-.09,2.74-.71,21.02-.08,2.4,2.21.94c14.88,6.31,29.76,12.63,44.64,18.94v21.93l-75.08,13.65-2.87.52v73.65c-1.07.61-2.13,1.22-3.2,1.83l-1.73.99-.03,2-.71,46.77-.04,2.71,2.62.71c.83.23,1.66.45,2.49.68-.27,6-.55,11.99-.82,17.99l-.12,2.57,2.42.88c1.82.66,3.64,1.32,5.46,1.98-.22,15.39-.45,30.78-.67,46.17l-.03,2.12,1.87,1.01,51.73,27.87,1.23.66,1.34-.36c24.28-6.53,48.56-13.07,72.84-19.6v33.77l1.07,1.03c.91.88,22.71,21.49,66.75,23.66,44.7,2.2,61.22-21.79,61.9-22.81l.58-.87v-1.04c.25-25.79,2.33-252.18.65-260.78-1.66-8.53-14.49-13.95-20.5-16.05-.15-30.34-.31-60.68-.46-91.02l-.02-4.35-4.24.95-45.35,10.16-10.71,2.4,10.12,4.24c4.17,1.75,8.33,3.49,12.5,5.24v66.8c-5.22-.36-12.93.07-19.47.62-17.63,1.47-36.01,6.85-40.75,8.3ZM1677.79,1560.29l36.85,8.5,4.29.99v-16.07l-2.6-.69c-9.21-2.45-18.42-4.89-27.63-7.34v-118.22c2.35-.11,4.7-.21,7.05-.32l3.04-.14.29-3.03.95-9.92.31-3.26-3.23-.53-75.12-12.28-.41-.07-.41.03-12.76.94-3.21.24-.03,3.21-1.42,131.81-.03,2.88,2.82.58c22.74,4.7,45.49,9.4,68.24,14.1.1,1.78.21,3.57.32,5.35l.15,2.62,2.55.59ZM1718.93,2029.79v-13.29l-2.27-.85c-9.31-3.49-18.62-6.98-27.94-10.48.45-40.45.9-80.9,1.35-121.35,1.9-.1,3.8-.2,5.7-.3l2.2-.11.85-2.03,2.36-5.67,1.48-3.55-3.67-1.14-80.79-25.04-.93-.29-.95.24-9.45,2.36-2.65.66v134.16l2.31.84c22.75,8.24,45.49,16.49,68.24,24.73.11,1.76.22,3.51.33,5.27l.13,2.14,1.96.85,36.85,16.06,4.9,2.14v-5.34Z"></path>
          </g>
        </g>
      </g>
      <g id="Icons">
        <g id="fassade-2" data-name="fassade" onPointerEnter={()=>{enter_element("fassade")}} onPointerLeave={()=>{leave_element("fassade")}} onClick={()=>{click_element("fassade")}} style={icon_styling_function("fassade")}>
          <g>
            <g className="cls-13">
              <path className="cls-5" d="M2085.88,1122.1c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
            </g>
            <path className="cls-32" d="M2108.81,1057.02v-22.89h-45.84v22.89h-19.53v29.33h84.88v-29.33h-19.53.02ZM2069.71,1040.89h32.32v15.81h-32.32v-15.81ZM2050.2,1079.59v-15.81h32.28v15.81h-32.28ZM2121.56,1079.59h-32.28v-15.81h32.28v15.81Z"></path>
          </g>
        </g>
        <g id="dach-2" data-name="dach" onPointerEnter={()=>{enter_element("dach")}} onPointerLeave={()=>{leave_element("dach")}} onClick={()=>{click_element("dach")}} style={icon_styling_function("dach")}>
          <g className="cls-20">
            <path className="cls-5" d="M1598.8,293.47c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
          </g>
          <path className="cls-32" d="M1645.04,251.62l-16.6-41.02h-57.21l.07.18-15.45,37.08,6.24,2.59,12.82-30.75,12.93,31.92h57.21-.01ZM1623.89,217.35l11.13,27.5h-42.64l-11.13-27.5h42.64Z"></path>
        </g>
        <g id="photovoltaik-2" data-name="photovoltaik" onPointerEnter={()=>{enter_element("photovoltaik")}} onPointerLeave={()=>{leave_element("photovoltaik")}} onClick={()=>{click_element("photovoltaik")}} style={icon_styling_function("photovoltaik")}>
          <g id="icon">
            <g className="cls-18">
              <path className="cls-5" d="M1243.38,404.06c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
            </g>
            <polygon className="cls-32" points="1244.24 316.8 1259.98 316.8 1245.29 339.91 1265.61 339.91 1229.98 376.72 1242.3 351.08 1228.67 351.08 1244.24 316.8"></polygon>
          </g>
        </g>
        <g id="solarthermie-2" data-name="solarthermie" onPointerEnter={()=>{enter_element("solarthermie")}} onPointerLeave={()=>{leave_element("solarthermie")}} onClick={()=>{click_element("solarthermie")}} style={icon_styling_function("solarthermie")}>
          <g className="cls-19">
            <g>
              <path className="cls-5" d="M2101.64,451.07c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              <path className="cls-32" d="M2089.74,379.49c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.74,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.02Z"></path>
              <path className="cls-32" d="M2089.74,399.47c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.76,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.04Z"></path>
              <path className="cls-32" d="M2089.74,419.47c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.76,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.04Z"></path>
            </g>
          </g>
        </g>
        <g id="lueftung-2" data-name="lueftung" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={icon_styling_function("lueftung")}>
          <g id="lueftung-2" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={icon_styling_function("lueftung")}>
            <g className="cls-17">
              <g>
                <path className="cls-36" d="M1805.13,1321.49c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
                <path className="cls-32" d="M1818.94,1239.59c.54-7.66-5.14-17.41-12.68-21.78v31.47c0,6.69,1.69,11.13,3.78,9.91,3.76-2.18,8.9-10.25,8.9-19.6"></path>
                <path className="cls-32" d="M1793.57,1283.18c-.54,7.66,5.14,17.41,12.68,21.78v-31.47c0-6.69-1.69-11.13-3.78-9.91-3.76,2.18-8.9,10.25-8.9,19.6"></path>
                <path className="cls-32" d="M1784.47,1248.69c-7.66-.54-17.41,5.14-21.78,12.68h31.47c6.69,0,11.13-1.69,9.91-3.78-2.18-3.76-10.25-8.9-19.6-8.9"></path>
                <path className="cls-32" d="M1828.06,1274.05c7.66.54,17.41-5.14,21.78-12.68h-31.47c-6.69,0-11.13,1.69-9.91,3.78,2.18,3.76,10.25,8.9,19.6,8.9"></path>
              </g>
            </g>
          </g>
        </g>
        <g id="keller-2" data-name="keller" onPointerEnter={()=>{enter_element("keller")}} onPointerLeave={()=>{leave_element("keller")}} onClick={()=>{click_element("keller")}} style={icon_styling_function("keller")}>
          <g className="cls-14">
            <g>
              <g className="cls-11">
                <path className="cls-5" d="M1228.66,2436.79c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              </g>
              <path className="cls-32" d="M1259.88,2385.93h-62.44v-33.77l30.12-13.76,32.3,13.7v33.83h.02,0ZM1204.19,2379.17h48.93v-22.59l-25.45-10.79-23.47,10.72v22.66h-.01Z"></path>
              <rect className="cls-32" x="1197.43" y="2385.57" width="6.76" height="24.51"></rect>
              <rect className="cls-32" x="1253.12" y="2385.57" width="6.76" height="24.51"></rect>
              <rect className="cls-32" x="1197.8" y="2392.48" width="58.7" height="6.76"></rect>
              <g className="cls-15">
                <g className="cls-21">
                  <g>
                    <path className="cls-7" d="M1241.72,2331.14"></path>
                    <path className="cls-2" d="M1241.72,2331.14"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="fenster-2" data-name="fenster" onPointerEnter={()=>{enter_element("fenster")}} onPointerLeave={()=>{leave_element("fenster")}} onClick={()=>{click_element("fenster")}} style={icon_styling_function("fenster")}>
          <path className="cls-35" d="M2365.21,1506.78c33.59,0,60.8-27.23,60.8-60.82s-27.23-60.82-60.8-60.82-60.8,27.23-60.8,60.82,27.23,60.82,60.8,60.82"></path>
          <path className="cls-32" d="M2384.24,1472.81h-38.07v-26.38h6.89v12.21h6.76v-18.97h-13.65v-20.52h38.07v53.66h0ZM2339.41,1479.57h51.58v-67.17h-51.58v67.17Z"></path>
        </g>
        <g id="fenster-3" data-name="fenster">
          <path className="cls-35" d="M1699.54,842.03c33.59,0,60.8-27.23,60.8-60.82s-27.23-60.82-60.8-60.82-60.8,27.23-60.8,60.82,27.23,60.82,60.8,60.82"></path>
          <path className="cls-32" d="M1718.57,808.06h-38.07v-26.38h6.89v12.21h6.76v-18.97h-13.65v-20.52h38.07v53.66h0ZM1673.74,814.82h51.58v-67.17h-51.58v67.17Z"></path>
        </g>
        <g id="heizung-2" data-name="heizung" onPointerEnter={()=>{enter_element("heizung")}} onPointerLeave={()=>{leave_element("heizung")}} onClick={()=>{click_element("heizung")}} style={icon_styling_function("heizung")}>
          <g className="cls-12">
            <g>
              <path className="cls-34" d="M1659.6,2034.86c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              <path className="cls-32" d="M1629.82,1957.05c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1629.82,2001.68c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-32" d="M1652.63,1957.05c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1652.63,2001.68c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-32" d="M1675.45,1957.05c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1675.45,2001.68c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-32" d="M1695.77,1957.05c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1695.77,1971.33c-5.81,0-10.52-4.71-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.71,10.52,10.52-4.71,10.52-10.52,10.52"></path>
              <path className="cls-34" d="M1659.6,1570.14c33.59,0,60.82-27.23,60.82-60.8s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.8,60.82,60.8"></path>
              <path className="cls-32" d="M1629.82,1492.33c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1629.82,1536.96c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-32" d="M1652.63,1492.33c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1652.63,1536.96c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-32" d="M1675.45,1492.33c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1675.45,1536.96c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-32" d="M1695.77,1492.33c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1695.77,1506.62c-5.81,0-10.52-4.73-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.73,10.52,10.52-4.71,10.52-10.52,10.52"></path>
            </g>
          </g>
          <path className="cls-34" d="M1659.61,2439.51c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
          <path className="cls-32" d="M1629.83,2361.7c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1629.83,2406.33c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
          <path className="cls-32" d="M1652.64,2361.7c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1652.64,2406.33c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
          <path className="cls-32" d="M1675.46,2361.7c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1675.46,2406.33c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
          <path className="cls-32" d="M1695.78,2361.7c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1695.78,2375.98c-5.81,0-10.52-4.71-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.71,10.52,10.52-4.71,10.52-10.52,10.52"></path>
        </g>
      </g>
    </g>
  </g>
</svg>
    {/*END SVG*/}
    <div className={"house-img mehrfamilienmittelhaus-img"}></div>
  </>);
}

